export enum CompanyType {
    KOOPERATIVA = 1,
    KOMUNALNA = 2,
}